import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

const PARAM = {
    OPEN: `is-open`,
    SCROLLTO: true,
    HEADER: 100
}

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                trigger: 'toggle',
                childTrigger: 'childToggle'
            }
        }
    }

    setAttributes(el, attrs){
        for(var key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    }

    init() {
        this.moduleId = this.el.getAttribute('data-mid');

        let accordionTriggers = this.el.querySelectorAll('[data-accordion="trigger"]');
        let accordionContents = this.el.querySelectorAll('[data-accordion="content"]');

        let accordionCildTriggers = this.el.querySelectorAll('[data-accordion="childTrigger"]');
        let accordionCildContents = this.el.querySelectorAll('[data-accordion="childContent"]');

        if(accordionTriggers.length != accordionContents.length){
            throw new Error('Accordion : Number of triggers and contents does not match');
        }

        if(accordionCildTriggers.length != accordionCildContents.length){
            throw new Error('Accordion : Number of child triggers and contents does not match');
        }

        let i = 1;
        accordionTriggers.forEach(trigger => {
            this.setAttributes(trigger,{
                'id': this.moduleId+'-trigger-'+i,
                'aria-controls': this.moduleId+'-target-'+i,
                // 'aria-selected': "true",
                'aria-expanded': "false",
                'tabindex': '0'
            });

            i++;
        });

        let j = 1;
        accordionContents.forEach(content => {
            this.setAttributes(content,{
                'aria-labelledby': this.moduleId+'-trigger-'+j,
                'id': this.moduleId+'-target-'+j,
                'tabindex': '-1',
            });

            toggleChildsTabindex(content, '-1');

            j++;
        });

        let k = 1;
        accordionCildTriggers.forEach(trigger => {
            this.setAttributes(trigger,{
                'id': this.moduleId+'-childTrigger-'+k,
                'aria-controls': this.moduleId+'-childTarget-'+k,
                // 'aria-selected': "true",
                'aria-expanded': "false",
                'tabindex': '0'
            });

            k++;
        });

        let l = 1;
        accordionCildContents.forEach(content => {
            this.setAttributes(content,{
                'aria-labelledby': this.moduleId+'-childTrigger-'+l,
                'id': this.moduleId+'-childTarget-'+l,
                'tabindex': '-1',
            });

            l++;
        });

        let preOpenId = this.el.getAttribute('data-accordion-preopen');
        if(preOpenId && accordionContents[preOpenId]){
            let preOpenElement = accordionContents[preOpenId];
            preOpenElement.closest('[data-accordion="wrap"]').classList.add(PARAM.OPEN);
            toggleChildsTabindex(preOpenElement, '0');
        }
    }

    /**
     * Toggle Action
     *
     * @param el {node}
     */
    toggle(el) {
        let target = el.currentTarget
        let parent = target.closest('[data-accordion="wrap"]')
        if (parent && parent.classList.contains(PARAM.OPEN)) {
            this.close()
        } else if (parent) {
            this.close()
            this.open(parent)
        } else {
            throw new Error('Invalid target')
        }
    }

    childToggle(el) {
        let target = el.currentTarget
        let parent = target.closest('[data-accordion="childWrap"]')
        if (!parent) {
            throw new Error(`No parent found for element ${el}`)
        }
        if (parent.classList.contains(PARAM.OPEN)) {
            this.childClose()
        } else {
            this.childClose()
            this.childOpen(parent)
        }
    }

    /**
     * Open Action
     *
     * @param el {node}
     */
    open(el) {
        el.classList.add(PARAM.OPEN);
        let curContent = el.querySelector('[data-accordion="content"]')
        let curTrigger = el.querySelector('[data-accordion="trigger"]')

        curTrigger.setAttribute('aria-expanded','true')
        toggleChildsTabindex(curContent, '0')

        if (PARAM.SCROLLTO) {
            setTimeout(function () {
                let newTop = window.pageYOffset + el.getBoundingClientRect().top - PARAM.HEADER;
                window.scrollTo({
                    top: newTop,
                    behavior: 'smooth'
                })
            }, 500)
        }
    }

    childOpen(el) {
        el.classList.add(PARAM.OPEN);
        let curContent = el.querySelector('[data-accordion="childContent"]')
        let curTrigger = el.querySelector('[data-accordion="childTrigger"]')

        curTrigger.setAttribute('aria-expanded','true')
        toggleChildsTabindex(curContent, '0')
    }

    /**
     * Close Action
     *
     * @param
     */
    close() {
        this.$('wrap').forEach((item) => {
            let curTrigger = item.querySelector('[data-accordion="trigger"]')
            let curContent = item.querySelector('[data-accordion="content"]')
            item.classList.remove(PARAM.OPEN)
            curTrigger.setAttribute('aria-expanded','false');
            curContent.setAttribute('tabindex','-1');
            toggleChildsTabindex(curContent, '-1');
        })
    }

    childClose() {
        this.$('childWrap').forEach((childWrap) => {
            let childTrigger = childWrap.querySelector('[data-accordion="childTrigger"]')
            let childContent = childWrap.querySelector('[data-accordion="childContent"]')
            childWrap.classList.remove(PARAM.OPEN)
            childTrigger.setAttribute('aria-expanded','false');
            childContent.setAttribute('tabindex','-1');
        })
    }
}

/* 
// USAGE :
//  data-accordion-toggle = auto close already open accordion
//  data-accordion-scroll = Scroll to open accordion
//  data-accordion-preopen="0" = Pre Open accordion matching index

<div class="c-accordion" data-module="Accordion" data-accordion-toggle data-accordion-scroll data-accordion-preopen="0">
    <?php for($i=1; $i<=8; $i++): ?>
        <div class="c-accordion__section" data-accordion="wrap">
            <div class="c-accordion__header">
                <h3 class="c-accordion__header__title">
                    <?php $accordionTitle = "Titre de mon accordion - ".$i; ?>
                    <button class="c-accordion__button" aria-expanded="false" data-accordion="trigger" type="button" aria-label="Ouvrir <?=$accordionTitle; ?>">
                        <?=$accordionTitle; ?>
                    </button>
                </h3>
            </div>
            <div class="c-accordion__content" role="region" data-accordion="content">
                <div class="c-accordion__inner">
                    <div class="o-text">
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellat rem nisi soluta commodi harum deleniti, voluptatem itaque doloremque temporibus labore fugit iusto nesciunt esse rerum vitae, deserunt quidem aliquid error!</p>
                    </div>
                </div>
            </div>
        </div>
    <?php endfor; ?>
</div>
*/

/*
// Accordion with child

<div class="c-accordion" data-module="Accordion" data-accordion-toggle data-accordion-scroll data-accordion-preopen="0">
    <?php for($i=1; $i<=8; $i++): ?>
        <div class="c-accordion__section" data-accordion="wrap">
            <div class="c-accordion__header">
                <h3 class="c-accordion__header__title">
                    <?php $accordionTitle = "Titre de mon accordion - ".$i; ?>
                    <button class="c-accordion__button" aria-expanded="false" data-accordion="trigger" type="button" aria-label="Ouvrir <?=$accordionTitle; ?>">
                        <?=$accordionTitle; ?>
                    </button>
                </h3>
            </div>
            <div class="c-accordion__content" role="region" data-accordion="content">
                <div class="c-accordion__inner">
                    <div class="o-text">
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellat rem nisi soluta commodi harum deleniti, voluptatem itaque doloremque temporibus labore fugit iusto nesciunt esse rerum vitae, deserunt quidem aliquid error!</p>

                        <div class="c-accordion__child">
                            <div class="c-accordion__section" data-accordion="childWrap">
                                <div class="c-accordion__header">
                                    <h3 class="c-accordion__header__title">
                                        <?php $accordionTitle = "Titre de mon accordion" ?>
                                        <button class="c-accordion__button" data-accordion="childTrigger" type="button" aria-label="Ouvrir <?= $accordionTitle; ?>">
                                            <?= $accordionTitle; ?>
                                            <span class="c-accordion__header__icon"><?php svg('arrow-right'); ?></span>
                                        </button>
                                    </h3>
                                </div>
                                <div class="c-accordion__content" data-accordion="childContent">
                                    <div class="c-accordion__inner">
                                        <div class="o-text">
                                            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellat rem nisi soluta commodi harum deleniti, voluptatem itaque doloremque temporibus labore fugit iusto nesciunt esse rerum vitae, deserunt quidem aliquid error!</p>
                                            <a href="#" class="o-button" title="Consulter la page <?= $accordionTitle; ?>">
                                                En savoir plus
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    <?php endfor; ?>
</div>

*/